import "./ConvertCurrentTemperature.css";

export default function ConvertCurrentTemperature(props) {
  function displayFahrenheit(event) {
    event.preventDefault();
    props.setUnit("fahrenheit");
  }

  function displayCelsius(event) {
    event.preventDefault();
    props.setUnit("celsius");
  }

  let temperature = Math.round(props.temperature);

  if (props.unit === "fahrenheit") {
    temperature = Math.round(props.temperature * (9 / 5) + 32);
  }

  return (
    <div className="convert-current-temperature">
      <span className="current-temperature"> {temperature} </span>
      <span className="current-temperature-unit">
        <a href="/" onClick={displayCelsius}>
          °C
        </a>{" "}
        |{" "}
        <a href="/" onClick={displayFahrenheit}>
          °F
        </a>
      </span>
    </div>
  );
}
